<template>
  <div class="row">
    <div class="col-lg-4">
      <table class="table table-hover" v-if="site.order">
        <thead>
        <tr>
          <th>Build Stage</th>
          <th>Started</th>
          <th>Completed</th>
          <th>By</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="site.buildActions.length < 1">
          <td colspan="4">
            <button class="btn btn-xs btn-primary m-t-sm pull-right" @click="addBuildFlow">Add Build Flow</button>
          </td>
        </tr>
        <tr v-for="(action, name) in site.buildActions" :key="name" :class="action.status">
          <td>
            <i class="fa fa-check" v-if="action.status === 'completed'"></i>
            <i class="fa fa-clock" v-if="action.status === 'started'"></i>
            <i class="fa fa-remove" v-if="action.status === 'waiting'"></i>
            <i class="fa fa-ban" v-if="action.status === 'na'"></i>
            <b>{{ ucFirst(action.action).replace('-', ' ') }}</b>
          </td>
          <td>
            <span v-if="action.status !== 'na' && action.status !== 'waiting'">
              {{ action.startTime ? $moment(action.startTime.date).format('DD.MM.') : '/' }}
            </span>
          </td>
          <td>
            <span v-if="action.status === 'completed'">
              {{ action.endTime ? $moment(action.endTime.date).format('DD.MM.') : '' }}
            </span>
            <button class="btn btn-xs btn-danger" v-if="action.status === 'waiting'" @click="patchAction(action.action, 'na')">N/A</button>
            <button class="btn btn-xs btn-primary" v-if="action.status === 'started'" @click="patchAction(action.action, 'completed')">Complete</button>
            <a><i
              class="fas fa-undo red"
              title="Mark not completed"
              v-if="(action.status === 'completed' || action.status === 'started' || action.status === 'na') && user.admin"
              @click="patchAction(action.action, action.status === 'completed' ? 'started' : 'waiting', 'Roll action back?')"
            ></i></a>
          </td>
          <td>
            <button class="btn btn-xs btn-primary" v-if="action.status === 'waiting'" @click="patchAction(action.action, 'started')">Start</button>
            <span v-if="action.status ==='completed' || action.status === 'started'">
              <edit
                :text="action.assignee ? action.assignee.username : '/'"
                :locked="!user.admin"
                type="select"
                :options="builders"
                :selected-value="action.assignee ? action.assignee.id : null"
                :close-on-save="true"
                @input="updateAction($event, action.action, 'assignee')"
              ></edit>
            </span>
          </td>
        </tr>
        <tr v-if="site.buildActions && site.buildActions.length !== 0 && site.buildActions.built.status !== 'completed'">
          <td colspan="4">
            <button class="btn btn-xs btn-primary m-t-sm pull-right" @click="removeBuildFlow">Remove Build Flow</button>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover" v-else>
        <thead>
        <tr>
          <th>Add the site to an order to see build flow</th>
        </tr>
        </thead>
      </table>
      <table class="table table-hover">
        <thead>
        <tr>
          <th colspan="2">
            Backups
            <button class="btn btn-xs btn-primary pull-right">Create</button>
            <button class="btn btn-xs btn-success pull-right m-r-xs" @click="fetchBackups">Fetch</button>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(bkp, i) in site.backups" :key="'backup-' + i">
          <td>
            {{ bkp }}
          </td>
          <td class="col-lg-2">
            <a><i class="fa fa-upload pointer" v-tooltip="'Deploy to production'" @click="deployProd(0, bkp)"></i></a>
            <a><i class="fa fa-download pointer" v-tooltip="'Assign to Template'"></i></a>
            <a><i class="fa fa-plus pointer" v-tooltip="'Create a Template'"></i></a>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Upload files</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <input type="file" name="" id="fileUpload">
            <button @click="uploadFile">Upload</button>
          </td>
        </tr>
        <tr v-for="file in site.files" :key="file.name">
          <td>
            <a :href="'https://api.aphexmedia.com/files/uploads/' + file.name">{{ file.originalName }}</a>
          </td>
          <td>{{ Math.round((file.size / 1024 + Number.EPSILON) * 10) / 10 }}KB</td>
          <td></td>
        </tr>
        <tr>
          <td>
<!--            <dz id="dropzone" :options="dropzoneOptions" v-if="dropzoneOptions" ref="dz"></dz>-->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-4">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>Build Info</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="site.order">
          <td colspan="2">{{ site.order.description }}</td>
        </tr>
        <tr>
          <td>Priority</td>
          <td>
            <span v-if="user.admin">
              <v-select :options="priorities" v-model="buildInfo.priority" @input="changeInfo('priority')" index="index"></v-select>
            </span>
            <span v-else>
              <div class="label label-warning m-r-xs" v-if="buildInfo.priority >= 3">High</div>
              <div class="label label-primary m-r-xs" v-if="buildInfo.priority === 2">Normal</div>
              <div class="label label-default m-r-xs" v-if="buildInfo.priority <= 1">Low</div>
            </span>
          </td>
        </tr>
        <tr>
          <td>Language</td>
          <td>
            <span v-if="user.admin || user.roles.length">
              <v-select :options="langs" v-model="buildInfo.language" @input="changeInfo('language')" index="index"></v-select>
            </span>
            <span v-else>{{ site.buildInfo ? site.buildInfo.language : '/' }}</span>
          </td>
        </tr>
        <tr>
          <td>Topic</td>
          <td>
            <div v-if="user.admin || user.roles.length"  class="input-group">
                <input type="text" name="" id="" class="form-control" v-model="buildInfo.topic">
                <div class="input-group-append">
                  <button type="button" class="btn btn-primary" @click="changeInfo('topic')">Save</button>
                </div>
            </div>
            <span v-else>{{ site.buildInfo ? site.buildInfo.topic : '/' }}</span>
          </td>
        </tr>
        <tr>
          <td>Deadline</td>
          <td>
            <span v-if="user.admin">
              <input type="date" class="form-control" v-model="buildInfo['deadline']" @input="changeInfo('deadline')">
            </span>
            <span v-else>{{ buildInfo.deadline ? $moment(buildInfo.deadline).format('DD.MM.YYYY') : '/' }}</span>
          </td>
        </tr>
        <tr>
          <td>Design Style</td>
          <td>
            <edit
              :text="site.buildInfo ? site.buildInfo.designStyle : '/'"
              :locked="!user.admin"
              type="select"
              :options="designStyles"
              :selected-value="site.buildInfo ? site.buildInfo.designStyle : null"
              :close-on-save="true"
              @input="changeInfo('designStyle', $event)"
            ></edit>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { String } from '../../../../../mixins/helperMixin'
import axios from 'axios'
import { PBN_SET } from '../../../../../store/mutation-types'
import EditText from '../../../../Helpers/Form/EditText'

export default {
  data () {
    return {
      designStyles: [
        'Basic Blog',
        'Premium Blog',
        'Premium Magazine',
        'Premium Business'
      ],
      builders: [],
      priorities: [
        {
          label: 'Low',
          index: 1
        },
        {
          label: 'Normal',
          index: 2
        },
        {
          label: 'High',
          index: 3
        }
      ],
      buildInfo: {},
      dropzoneOptions: null
    }
  },
  components: {
    edit: EditText
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      user: 'getUser',
      langs: 'getLanguages'
    })
  },
  mounted () {
    if (!this.langs.length) {
      this.$store.dispatch('loadLanguages')
    }

    if (this.user.admin && this.builders.length < 1) {
      this.getBuilders()
    }

    this.dropzoneOptions = {
      url: process.env.API + '/pbn/' + this.site.punyDomain + '/build/file',
      headers: { 'Authorization': localStorage.getItem('token') }
    }

    this.buildInfo = {...this.site.buildInfo}
  },
  mixins: [String],
  methods: {
    patchAction (action, status, con = false) {
      if (con !== false) {
        if (!confirm(con)) {
          return
        }
      }
      axios.patch('/pbn/' + this.site.punyDomain + '/build/action', {
        action: action,
        status: status
      })
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error(e, 'Not again...')
        })
    },
    getBuilders () {
      axios.get('/users?pbnPermission=1&operator=6163160e757197395775b0f2')
        .then(r => {
          r.data.forEach(u => {
            this.builders.push({
              value: u.id,
              text: u.name || u.username
            })
          })
        })
        .catch()
    },
    changeInfo (option, val = null) {
      let data = {}
      if (val) {
        data['buildInfo.' + option] = val
      } else {
        data['buildInfo.' + option] = this.buildInfo[option]
      }
      axios.patch('/pbn/site/' + this.site.punyDomain, data)
        .then(r => {
          this.$toastr.success(option + ' has been updated', 'Oh yes!')
        })
        .catch(e => {})
    },
    uploadFile () {
      let formData = new FormData()
      let file = document.querySelector('#fileUpload')
      formData.append('file', file.files[0])
      axios.post('/pbn/' + this.site.punyDomain + '/build/file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(r => {
        this.$toastr.success('File Uploaded', 'Yasss!')
        this.$store.commit(PBN_SET, r.data.pbn)
      }).catch(e => {
        this.$toastr.error(e, 'QQ')
      })
    },
    addBuildFlow () {
      axios.post('/pbn/' + this.site.punyDomain + '/build/flow')
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.$toastr.success('Build flow added', 'GZ')
        })
        .catch(e => {})
    },
    removeBuildFlow () {
      if (confirm('Are you absolutely sure you want to remove existing build flow? All the flow data will be lost!')) {
        axios.delete('/pbn/' + this.site.punyDomain + '/build/flow')
          .then(r => {
            this.$store.commit(PBN_SET, r.data.pbn)
            this.$toastr.success('Build flow deleted', 'GZ')
          })
          .catch(e => {})
      }
    },
    updateAction (val, action, prop) {
      let data = {
        action: action
      }
      data[prop] = val
      axios.patch('/pbn/' + this.site.punyDomain + '/build/action', data)
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error(e, 'Not again...')
        })
    },
    deployProd (rebuild = 0, backup = 0) {
      axios.post(`/pbn/site/${this.site.punyDomain}/deploy?rebuild=${rebuild}&backup=${backup}`)
        .then(r => {
          this.$toastr.success('Deploy process has been started', 'Ok')
          this.$store.commit(PBN_SET, r.data.pbn)
        })
        .catch(e => {
          this.$toastr.error('Not good I guess', 'No')
        })
    },
    updateNsRecord (ip) {
      axios.patch(`/pbn/site/${this.site.punyDomain}/registrar/record`, {
        'type': 'A',
        'subdomain': '@',
        'record': ip
      })
        .then(r => {
          this.$toastr.success('The request has been sent. It could take a while before it propagates', 'NS Record Update Sent')
        }).catch()
    },
    updateHosting (guid) {
      axios.patch(`/pbn/site/${this.site.punyDomain}/hosting/host`, {
        hosting: guid
      })
        .then(r => {
          this.$store.commit(PBN_SET, r.data.pbn)
          this.hostingUpdating = true
        })
        .catch()
    },
    async fetchBackups () {
      const backups = await axios.get(`/pbn/site/${this.site.punyDomain}/staging/backups`)
      this.$store.commit(PBN_SET, backups.data.pbn)
      this.$toastr.success('Backups fetched')
    }
  }
}
</script>
<style>
.input-group-append {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Build.vue